<template>
  <Field @save="save">
    <template v-slot:view>
      {{ job2.ClientOrderNumber ? job2.ClientOrderNumber : "None" }}
    </template>
    <template v-slot:edit>
      <v-text-field v-model="purchaseOrder" label="Purchase Order"/>
    </template>
  </Field>
</template>

<script>
import Field from "../../Field"

export default {
  name: "JobPurchaseOrder",
  permissions: ["Modify Job"],
  props: ["job"],
  components: {
    Field
  },
  methods: {
    save: function () {
      const data = {
        Job: {
          ID: this.job2.ID,
          Name: this.job2.Name,
          StartDate: this.job2.StartDate.substr(0, 10).replace(/-/g, ""),
          DueDate: this.job2.DueDate.substr(0, 10).replace(/-/g, ""),
          ClientNumber: this.purchaseOrder,
          Budget: this.job2.Budget || 0,
          CategoryUUID: this.job2.CategoryUUID,
          Description: this.job2.Description || "."
        }
      }
      console.log(data)
      this.$WfmApi.put("job.api/update", data).then((response) => this.processResponse(response))
    },

    processResponse(response) {
      console.log(response)
      this.job2 = response.Job
      this.$emit("updated")
    }
  },
  mounted() {
    this.job2 = this.$clone(this.job)
    this.purchaseOrder = this.job2.ClientOrderNumber || ""
  },
  data() {
    return {
      job2: {},
      purchaseOrder: ""
    }
  }
}
</script>


